





























































































































































































import { Component } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { SwButton } from '@libs-uuif/shared/sw-button';
import { SwBlockingProgress } from '@libs-uuif/shared/sw-blocking-progress';
import { SwContentToolbar } from '@libs-uuif/shared/sw-content-toolbar';
import { SwFlexLayout, FlexLayoutUnit } from '@libs-uuif/shared/sw-flex-layout';
import { tooltip, TooltipDirValues } from '@libs-uuif/shared/tooltip-dir';
import { SwIcon } from '@libs-uuif/shared/sw-icon';
import { confirmService } from '@sonicwall/unified-ui-framework/src/shared/confirm-service';
import {
  SwTable,
  SwTableColumnSelection,
  TableColumnConfig,
  ColumnsAdjustRequestData,
  ColumnSortRequestData,
  SortedColumnInfo,
  TableEntry,
  PaginationConfig,
  PageNumberChangeRequestData,
  PageSizeChangeRequestData,
} from '@libs-uuif/shared/sw-table';
import { SwToggle } from '@libs-uuif/shared/sw-toggle';
import { SwSelect } from '@libs-uuif/shared/sw-select';
import { SwExpandableTextfield } from '@libs-uuif/shared/sw-textfield';
import { SwActionBar, SwActionBarItem } from '@libs-uuif/shared/sw-action-bar';
import { SwMessageContainer } from '@libs-uuif/shared/message-service';
import { SwIconButton } from '@libs-uuif/shared/sw-icon-button';
import { CustomDropdown } from '@/shared/custom-dropdown';
import { InfoState } from '@/core/core.store';
import { CreateElement, VNode } from 'vue';
import { VueRenderFunction } from '@sonicwall/unified-ui-framework/src/shared/common-types';
import DattoConfigurationWizard from './datto-configuration-wizard.vue';
import ErrorLogs from '../error-logs.vue';
import _ from 'lodash';

const cssPrefix = 'sw-ftr-flex-layout';

@Component({
  components: {
    SwTable,
    SwTableColumnSelection,
    SwFlexLayout,
    SwButton,
    SwBlockingProgress,
    SwSelect,
    SwContentToolbar,
    SwExpandableTextfield,
    SwIcon,
    SwActionBar,
    SwActionBarItem,
    SwMessageContainer,
    SwIconButton,
    CustomDropdown,
    DattoConfigurationWizard,
    ErrorLogs,
  },
  directives: {
    tooltip,
  },
})
export default class DattoAutotaskPage extends SwExtendedVue {

  cssPrefix = cssPrefix;
  searchTenant: string = '';
  searchBarExpanded: boolean = false;
  // isIntegrationConfigured: boolean = false;
  disableConfigure: boolean = false;
  cwCompanyOptions: any = [];
  defaultCompany: string = 'Select Account';
  defaultAgreement: string = 'Select Contract';

  totalBlocks: number = 5;
  blockPerLine: number = 5;
  tableLoader: boolean = false;
  allData: TableEntry[] = [];
  showSyncStatusMessage: boolean = false;
  syncStatusMesaage: string = '';
  initiateSync: boolean = false;

  // below flag is used to show/hide the configuration modal
  displayConfigurationModal: boolean = false;

  // column adjust
  adjustedColumns: ColumnsAdjustRequestData = {};
  onRequestAdjustColumns(data: ColumnsAdjustRequestData) {
    this.adjustedColumns = data;
  }

  // sorting table
  sortedColumns: SortedColumnInfo[] = [];
  onRequestSorting(data: ColumnSortRequestData) {
    data.cancel = false;
    const index = this.sortedColumns.findIndex(col => (col.colKey === data.colKey));
    if (index < 0) {
      if (data.cancel) { return; }
      this.sortedColumns.splice(0);
      this.sortedColumns.push({
        colKey: data.colKey,
        ascending: !!data.ascending,
      });
    } else {
      if (data.ascending === undefined) {
        this.sortedColumns[index].ascending = !this.sortedColumns[index].ascending;
        return;
      }
      this.sortedColumns[index].ascending = !!data.ascending;
    }
  }

  // For error logs
  errorLogsList: any = [];
  errorLogsModal:boolean = false;

  // For pagination
  tempPageNumber: number = 1;
  paginationConfig: PaginationConfig = {
    pageNumber: 1,
    pageSize: 10,
  };

  // tenant table columns configuration
  get tenantTableColumnsConfig(): TableColumnConfig[] {
    return [
      {
        key: 'tenantName',
        dataKey: 'tenantName',
        title: this.$t('userGroups.Customer')
        .toString(),
        sorter: true,
        width: 300,
      },
      {
        key: 'lastUpdated',
        dataKey: 'lastUpdated',
        title: this.$t('psaIntegration.lastUpdated')
        .toString(),
        width: 200,
      },
      {
        key: 'cwCompany',
        dataKey: 'cwCompany',
        title: this.$t('psaIntegration.dattoAutotask.autotaskAccounts')
        .toString(),
        width: 300,
        render: (h: CreateElement, data): VNode => { // tslint:disable-line
          return (
            <CustomDropdown
              dropdownLabel={data.entry.cwCompany}
              id={data.entry._key.toString()}
              key={data.entry._key.toString()}
              options={(this.cwCompanyOptions as any).companyOptions}
              limit={50}
              clearable={data.entry.cwCompany !== '' && data.entry.cwCompany !== this.defaultCompany}
              onClearSelection={() => {
                data.entry.agreement = this.defaultAgreement;
                data.entry.cwCompany = this.defaultCompany;
                data.entry.syncStatus = false;
                this.saveTenantData({ ...data.entry }, 'mapping');
              }}
              onOptionSelection={(e: string) => {
                if (data.entry.cwCompany !== e) {
                  data.entry.cwCompany = e;
                  data.entry.agreement = this.defaultAgreement;
                  this.saveTenantData({ ...data.entry }, 'mapping');
                }
              }
              }
            ></CustomDropdown>
          ) as VNode;
        },
      },
      {
        key: 'agreement',
        dataKey: 'agreement',
        title: this.$t('psaIntegration.dattoAutotask.contract')
        .toString(),
        width: 300,
        render: (h: CreateElement, data): VNode => { // tslint:disable-line
          let options = [];
          if (data.entry.cwCompany !== this.defaultCompany) {
            options = (this.cwCompanyOptions as any).agreementOptions ? (this.cwCompanyOptions as any).agreementOptions
              .filter((obj: any) => obj.company === data.entry.cwCompany)[0] : [];
          }
          return (
            <CustomDropdown
              dropdownLabel={data.entry.agreement}
              id={data.entry._key.toString()}
              key={data.entry._key.toString()}
              options={options ? options.agreements : []}
              limit={50}
              clearable={data.entry.agreement !== '' && data.entry.agreement !== this.defaultAgreement}
              onClearSelection={() => {
                data.entry.agreement = this.defaultAgreement;
                data.entry.syncStatus = false;
                this.saveTenantData({ ...data.entry }, 'mapping');
              }}
              onOptionSelection={(e: string) => {
                if (data.entry.agreement !== e) {
                  const matched:any = this.tenantsData.find((ele:any) => ele.agreement === e);
                  if (matched !== undefined) {
                    confirmService.confirm({
                      status: 'major',
                      message: this.renderTenantMatchMessage(matched?.tenantName),
                      buttons: [
                        {
                          key: 'cancel',
                          name: this.$t('common.cancel')
                          .toString(),
                        },
                        {
                          key: 'ok',
                          name: this.$t('common.confirm')
                          .toString(),
                          isDefault: true,
                        },
                      ],
                    })
                    .then((isConfirmed : any) => {
                      if (isConfirmed === 'ok') {
                        data.entry.agreement = e;
                        data.entry.syncStatus = true;
                        this.saveTenantData(data.entry, 'mapping');
                      } else {

                      }
                    });
                  } else {
                    data.entry.agreement = e;
                    data.entry.syncStatus = true;
                    this.saveTenantData(data.entry, 'mapping');
                  }
                }
              }}
            ></CustomDropdown>
          ) as VNode;
        },
      },
      {
        key: 'syncStatus',
        dataKey: 'syncStatus',
        title: this.$t('psaIntegration.syncStatus')
        .toString(),
        sorter: true,
        render: (h: CreateElement, data): VNode => { // tslint:disable-line
          if (data.entry.syncStatus === true) {
            // console.warn(data.entry);
            if (_.isEmpty(data.entry.syncDetails) || data.entry.syncDetails.sync_status && data.entry.syncDetails.sync_status === 'success') {
              return (
                <div style={{ display: 'flex' }}>
                  <SwToggle
                    value={data.entry.syncStatus}
                    name="basicSwitch"
                    disabled={
                      data.entry.cwCompany === this.defaultCompany ||
                      data.entry.cwCompany === '' ||
                      data.entry.agreement === this.defaultAgreement ||
                      data.entry.agreement === ''
                    }
                    onChange={() => {
                      data.entry.syncStatus = !data.entry.syncStatus;
                      this.saveTenantData(data.entry, 'syncStatus');
                    }}
                  />
                  <span>
                    <SwIcon style={{ marginLeft: '1.5rem' }} name="checkmark" color="#99cc00"/>
                  </span>
                </div>
              ) as VNode;
            }
            return (
                    <div style={{ display: 'flex' }}>
                      <SwToggle
                        value={data.entry.syncStatus}
                        name="basicSwitch"
                        disabled={
                          data.entry.cwCompany === this.defaultCompany ||
                          data.entry.cwCompany === '' ||
                          data.entry.agreement === this.defaultAgreement ||
                          data.entry.agreement === ''
                        }
                        onChange={() => {
                          data.entry.syncStatus = !data.entry.syncStatus;
                          this.saveTenantData(data.entry, 'syncStatus');
                        }}
                      />
                      <span>
                        <SwIcon
                          style={{ marginLeft: '1.5rem' }}
                          name="severity-minor"
                          v-tooltip={{
                            content: this.$t('psaIntegration.dattoAutotask.errorHelptext'),
                            compact  : true,
                            placement: 'top',
                          } as TooltipDirValues}
                          color="#FFCC00"
                        />
                      </span>
                      <span style={{ marginLeft: '1.5rem', fontSize: '14px' }}>
                        <a onClick={  () => {
                          this.errorLogsList = data.entry.syncDetails.errors;
                          this.errorLogsModal = true;
                        }}> { data.entry.syncDetails.error_count || '' } Errors
                        </a>
                      </span>
                    </div>
            ) as VNode;
          }
          return (
              <div style={{ display: 'flex' }}>
                <SwToggle
                  value={data.entry.syncStatus}
                  name="basicSwitch"
                  disabled={
                    data.entry.cwCompany === this.defaultCompany ||
                    data.entry.cwCompany === '' ||
                    data.entry.agreement === this.defaultAgreement ||
                    data.entry.agreement === ''
                  }
                  onChange={() => {
                    data.entry.syncStatus = !data.entry.syncStatus;
                    this.saveTenantData(data.entry, 'syncStatus');
                  }}
                />
              </div>
          ) as VNode;
        },
      },
    ];
  }

  renderTenantMatchMessage(tenantName: any): VueRenderFunction {
    // tslint:disable-next-line:no-unused
    return (h: CreateElement) => (
      <div> {this.$t('psaIntegration.dattoAutotask.contractmsg1')} <span style="font-weight: 700"> {tenantName}. </span>  {this.$t('psaIntegration.dattoAutotask.contractmsg2')}  </div>
    ) as VNode;
  }

  get responsiveLayoutUnit(): FlexLayoutUnit {
    const rootUnit: FlexLayoutUnit = {
      id: 'root',
      container: {
        direction: 'column',
        justifyContent: 'start',
        alignItems: 'stretch',
        items: [],
      },
    };
    const lines = Math.ceil(this.totalBlocks / this.blockPerLine);

    for (let i = 1; i <= lines; i += 1) {
      const rowUnit: FlexLayoutUnit = {
        id: `r${i}`,
        item: { flex: true },
        container: {
          direction: 'row',
          justifyContent: 'start',
          alignItems: 'start',
          items: [],
        },
      };
      rootUnit.container!.items.push(rowUnit);

      const blocks =
        i * this.blockPerLine > this.totalBlocks
          ? this.totalBlocks % this.blockPerLine
          : this.blockPerLine;

      for (let j = 1; j <= blocks; j += 1) {
        const count = (i - 1) * this.blockPerLine + j;
        const cellUnit: FlexLayoutUnit = {
          id: `${count}`,
          item: { flex: true },
          container: {
            justifyContent: 'start',
            alignItems: 'start',
            items: [],
          },
        };
        rowUnit.container!.items.push(cellUnit);
      }
    }
    return rootUnit;
  }

  get syncDetails() {
    return this.$store.getters['DattoAutotaskStoreModule/getSyncDetails'];
  }

  get isIntegrationConfigured() {
    console.warn(this.syncDetails);
    if (this.syncDetails.apiUserName === 'Not configured' || this.syncDetails.apiUserName === '' || this.syncDetails.api_user_name === '' || this.syncDetails.api_user_name === 'Not configured') {
      return true;
    }
    return false;
  }

  get basicData() {
    const tableData = this.$store.getters['DattoAutotaskStoreModule/getTenantsData'];
    if (tableData.length > 0) {
      this.paginationConfig.pageNumber =
        this.searchTenant === '' ? this.tempPageNumber : 1;
      const filteredData = this.getSearchedTenent();
      this.tableLoader = true;
      this.debouncedLoadedPartialDataset();
      return filteredData;
    }
    this.tableLoader = true;
    this.debouncedLoadedPartialDataset();
    return tableData;
  }

  get debouncedLoadedPartialDataset() {
    return _.debounce(
      () => { this.tableLoader = false; },
      600,
    );
  }

  getSearchedTenent(): TableEntry[] {
    const tableData = [...this.$store.getters['DattoAutotaskStoreModule/getTenantsData']];
    console.warn(tableData, 'tabledata');
    let filteredValue: TableEntry[] = [];
    if (this.searchTenant.length > 1 && this.searchTenant.charAt(0) === '!') {
      const searchedWord = this.searchTenant?.slice(1) || '';
      if (searchedWord) {
        filteredValue = tableData.filter((obj: any) => {
          return !obj.tenantName.toLowerCase()
            .includes(searchedWord.toLowerCase());
        });
      }
    } else {
      if (this.searchTenant.charAt(0) !== '!') {
        filteredValue = tableData.filter((obj: any) =>
          obj.tenantName.toLowerCase()
          .includes(this.searchTenant.toLowerCase()),
        );
      } else {
        filteredValue = tableData;
      }
    }
    return filteredValue;
  }

  onChangePageNumber(data: PageNumberChangeRequestData) {
    this.paginationConfig.pageNumber = data.pageNumber;
    this.tempPageNumber = this.paginationConfig.pageNumber;
    this.debouncedLoadedPartialDataset();
  }

  get tenantsData(): TableEntry[] {
    console.warn(this.basicData);
    return this.basicData;
  }

  onChangePageSizer(data: PageSizeChangeRequestData) {
    this.paginationConfig.pageSize = data.pageSize;
    this.paginationConfig.pageNumber = Math.min(
      this.paginationConfig.pageNumber,
      Math.ceil(this.tenantsData.length / this.paginationConfig.pageSize),
    );
    this.tempPageNumber = this.paginationConfig.pageNumber;
    this.debouncedLoadedPartialDataset();
  }

  get isSubmitted() {
    return this.$store.getters['DattoAutotaskStoreModule/getSubmitted'];
  }

  displayModal() {
    this.displayConfigurationModal = true;
  }

  hideConfigurationModal() {
    this.displayConfigurationModal = false;
    if (this.isSubmitted || (this.$store.getters['DattoAutotaskStoreModule/modalClosed'] === true)) {
      this.refreshData();
    }
  }

  async refreshData(enableLoading: boolean = true) {
    try {
      enableLoading && this.$store.commit('startLoading');
      await this.fetchSyncDetails();
      this.initiateSync = false;
      await this.fetchSyncJobStatus();
      await this.fetchTableDropdownValues();
      await this.fetchIntegrationDetails();
      if (enableLoading) { this.$store.commit('stopLoading'); }
    } catch  {
      if (enableLoading) { this.$store.commit('stopLoading'); }
    }
  }

  syncNow() {
    this.initiateSync = true;
    this.fetchSyncJobStatus();
  }

  // For updating the table row details
  saveTenantData(updatedRow: any, operation: string) {
    this.$store
      .dispatch('DattoAutotaskStoreModule/postTenantDetails', updatedRow)
      .then(() => {
        if (operation !== 'mapping') {
          const infoMsg = `${this.$t('psaIntegration.connectwiseManage.msg8.submsg1')
          .toString()} ${updatedRow.tenantName} ${this.$t('psaIntegration.connectwiseManage.msg8.submsg2')
          .toString()}`;
          this.showMessage(infoMsg, 'success');
        }
        this.fetchSyncDetails();
      })
      .catch((error) => {
        this.fetchSyncDetails();
        if (operation === 'mapping') {
          const infoMsg = `${this.$t('psaIntegration.connectwiseManage.msg7.submsg1')
          .toString()} ${updatedRow.tenantName} ${this.$t('psaIntegration.connectwiseManage.msg7.submsg3')
          .toString()}`;
          this.showMessage(infoMsg, 'failed');
        } else {
          const infoMsg = `${this.$t('psaIntegration.connectwiseManage.msg7.submsg2')
          .toString()} ${updatedRow.tenantName} ${this.$t('psaIntegration.connectwiseManage.msg7.submsg3')
          .toString()}`;
          this.showMessage(infoMsg, 'failed');
        }
        console.error(error);
      })
      .finally(() => {
        this.$store.commit('stopLoading');
      });
  }

  // For config wizard api
  async fetchIntegrationDetails() {
    this.$store.dispatch('DattoAutotaskStoreModule/fetchAutotaskIntegrationDetails')
      .then((result) => {
        const intDetails:any = result;
        // this.syncDetails = result;
        // this.cwCompanyOptions.unshift(this.initialCwCompanyOptions);
        console.warn(intDetails.userList);
        if (!intDetails.hasOwnProperty('userList')) {
          intDetails['userList'] = [];
        } else {
          let userList:any = intDetails['userList'];
          if (typeof userList === 'string') {
            userList = this.convertStringToArrayOfObjects(userList);
            // console.warn(userList);
            intDetails['userList'] = userList;
          }
          const currentUser = JSON.parse(this.$store.getters.getUserInfo).user.email;
          if (userList.some((ele:any) => ele.userName === currentUser)) {
            this.disableConfigure = true;
          }
        }
        console.warn('config details by api ', intDetails);
        this.$store.commit('DattoAutotaskStoreModule/setAutotaskIntegrationDetails', intDetails);
        // this.$store.commit('PSAIntegrationStoreModule/saveServerDetails', result['integration_config']);
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status !== 404 && error.response.status !== 401) {
            const infoMsg = `${this.$t('psaIntegration.dattoAutotask.msg1')
            .toString()}`;
            this.showMessage(infoMsg, 'failed');
            console.error(error);
          }
        }
      })
      .finally(() => {
        this.$store.commit('stopLoading');
      });
  }

  // Sync details for integration details and tenants table data
  async fetchSyncDetails() {
    this.tableLoader = true;
    await this.$store.dispatch('DattoAutotaskStoreModule/getSyncDetails')
      .then(async (result) => {
        if (result && result !== undefined && result !== {}) {
          this.$store.dispatch('DattoAutotaskStoreModule/setSyncDetailsToStore', result);
          this.allData = JSON.parse(JSON.stringify(result.tenants));
          await this.$store
          .dispatch('DattoAutotaskStoreModule/getTenantSyncStatus')
          .then((result) => {
            const syncStatusList = result || [];
            if (syncStatusList.length === 0) {
              this.allData.forEach((data:any) => {
                data['syncDetails'] = {};
              });
            } else {
              if (syncStatusList.some((e:any) => e['tenant_name'] === 'generic_err')) {
                if (syncStatusList.length > 1) {
                  const genricSyncItem = syncStatusList.filter((e:any) => e['tenant_name'] === 'generic_err');
                  syncStatusList.forEach((sList:any) => {
                    sList['error_count'] = sList['error_count'] + genricSyncItem[0]['error_count'];
                    sList['errors'] = [...sList['errors'], ...genricSyncItem[0]['errors']];
                  });
                }
              }
              if (syncStatusList.length === 1 && syncStatusList[0]['tenant_name'] === 'generic_err') {
                this.allData.map((data:any) => data['syncDetails'] = syncStatusList[0]);
              } else {
                this.allData.map((data:any) => syncStatusList.forEach((sList:any) => {
                  if (sList['tenant_name'] === data['tenantName']) { data['syncDetails'] = sList; }
                }));
              }
            }
          })
          .catch((error) => {
            if (error.response) {
              if (error.response.status !== 404 && error.response.status !== 401) {
                const infoMsg:string = this.$t('psaIntegration.connectwiseManage.msg4')
                .toString();
                this.showMessage(infoMsg, 'failed');
                console.error(error);
              }
            }
          })
          .finally(() => {
            this.$store.commit('stopLoading');
          });
          // console.warn(this.allData);
          // this.tenantsData = this.allData;
          this.$store.commit('DattoAutotaskStoreModule/setTenantsData', this.allData);
        }
        if (this.tableLoader) {
          this.tableLoader = false;
        }
        // this.cwCompanyOptions.unshift(this.initialCwCompanyOptions);
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status !== 404 && error.response.status !== 401) {
            const infoMsg:string = this.$t('psaIntegration.dattoAutotask.msg2')
            .toString();
            this.showMessage(infoMsg, 'failed');
            console.error(error);
          }
        }
      })
      .finally(() => {
        this.$store.commit('stopLoading');
        if (this.tableLoader) {
          this.tableLoader = false;
        }
      });
  }

  // Table dropdown api's
  async fetchTableDropdownValues() {
    const req: any = {
      isForced: 'TRUE',
    };
    this.$store.dispatch('DattoAutotaskStoreModule/getCompanyList', req)
      .then((result) => {
        this.cwCompanyOptions = result;
        // this.cwCompanyOptions.unshift(this.initialCwCompanyOptions);
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status !== 404 && error.response.status !== 401) {
            const infoMsg:string = this.$t('psaIntegration.dattoAutotask.msg3')
            .toString();
            this.showMessage(infoMsg, 'failed');
            console.error(error);
          }
        }
      })
      .finally(() => {
        this.$store.commit('stopLoading');
      });
  }

  // Sync Operation Apis
  async fetchSyncJobStatus() {
    this.$store
      .dispatch('DattoAutotaskStoreModule/getSyncJobStatus')
      .then(async (result) => {
        if (result.status === 'completed' || result.status === 'failed' || result.status === 'N/A') {
          this.showSyncStatusMessage = false;
          if (this.initiateSync) {
            await this.initiateSyncOperation();
            await this.fetchSyncDetails();
            await this.fetchTableDropdownValues();
          }
        } else {
          if (result.status === 'created') {
            this.showSyncStatusMessage = true;
            this.syncStatusMesaage = `${this.$t('psaIntegration.dattoAutotask.msg4.submsg1')
            .toString()} ${result.time} ${this.$t('psaIntegration.dattoAutotask.msg4.submsg4')
            .toString()}`;
          } else if (result.status === 'started') {
            this.showSyncStatusMessage = true;
            this.syncStatusMesaage = `${this.$t('psaIntegration.dattoAutotask.msg4.submsg2')
            .toString()} ${result.time} ${this.$t('psaIntegration.dattoAutotask.msg4.submsg4')
            .toString()}`;
          } else if (result.status === 'queued') {
            this.showSyncStatusMessage = true;
            this.syncStatusMesaage = `${this.$t('psaIntegration.dattoAutotask.msg4.submsg3')
            .toString()} ${result.time} ${this.$t('psaIntegration.dattoAutotask.msg4.submsg4')
            .toString()}`;
          }
          // this.showMessage(`Could not initiate sync operation. An existing sync operation is in progress for last ${result.time}.`, 'failed');
        }
      })
      .catch((error) => {
        const infoMsg:string = this.$t('psaIntegration.connectwiseManage.msg2')
        .toString();
        this.showMessage(infoMsg, 'failed');
        console.error(error);
      })
      .finally(() => {
        this.$store.commit('stopLoading');
      });
  }

  async initiateSyncOperation() {
    this.initiateSync = false;
    this.syncStatusMesaage = this.$t('psaIntegration.dattoAutotask.msg5')
    .toString();
    this.$store
      .dispatch('DattoAutotaskStoreModule/startSyncNow')
      .then(() => {
        console.warn('started sync operation');
        this.showSyncStatusMessage = true;
        this.$store.commit('stopLoading');
        const infoMsg:string = this.$t('psaIntegration.connectwiseManage.msg1')
        .toString();
        this.showMessage(infoMsg, 'success');
      })
      .catch((error) => {
        this.showSyncStatusMessage = false;
        this.$store.commit('stopLoading');
        const infoMsg:string = this.$t('psaIntegration.connectwiseManage.msg2')
        .toString();
        this.showMessage(infoMsg, 'failed');
        console.error(error);
      })
      .finally(() => {
        this.$store.commit('stopLoading');
      });
  }

  async created() {
    const tableData:any = this.$store.getters['DattoAutotaskStoreModule/getTenantsData'];
    console.warn('tabledata created', tableData);
    if (tableData.length === 0) {
      await this.refreshData();
    }
  }

  // For error logs dialog events
  closeErrorLogDialog() {
    this.errorLogsModal = false;
  }

  convertStringToArrayOfObjects(list: any) {
    let data = list.replace(/[[\]]/g, '');
    data = data.split(', {');
    const tempData: any = [];
    data.forEach((item: any, index: number) => {
      let currItem = item.replace(/'/g, '"');
      if (index > 0) {
        currItem = `{${currItem}`;
      }
      console.warn(currItem);
      tempData.push(JSON.parse(currItem));
    });
    // console.warn(tempData);
    return tempData;
  }

   // For toaster message
  showMessage(infoMsg: string, infoType: string): void {
    // success and failed
    const message: InfoState = { infoType, infoMsg };
    this.$store.commit('displayMessage', message);
  }
}
